export const INIT = 'INIT'

export const ADD_ITEM = 'ADD_ITEM'

export const ADD_ITEM_TEXTBOX = 'ADD_ITEM_TEXTBOX'
export const ADD_ITEM_IMAGE = 'ADD_ITEM_IMAGE'
export const ADD_ITEM_FIELD_SELECT = 'ADD_ITEM_FIELD_SELECT'
export const ADD_ITEM_QR_CODE = 'ADD_ITEM_QR_CODE'
export const ADD_ITEM_BAR_CODE = 'ADD_ITEM_BAR_CODE'
export const ADD_ITEM_BAR_CODE_NT = 'ADD_ITEM_BAR_CODE_NT'
export const ADD_ITEM_AP_LOGO = 'ADD_ITEM_AP_LOGO'
export const ADD_ITEM_COMPANY_LOGO = 'ADD_ITEM_COMPANY_LOGO'

export const REMOVE_ITEM = 'REMOVE_ITEM'
export const UPDATE_ITEM = 'UPDATE_ITEM'
export const DESELECT_ALL_ITEM = 'DESELECT_ALL_ITEM'
export const SELECT_ITEM = 'SELECT_ITEM'

export const ZOOM = 'ZOOM'
